import { render, staticRenderFns } from "./DonutChart35.vue?vue&type=template&id=3b7aebf3&scoped=true"
import script from "./DonutChart35.vue?vue&type=script&lang=js"
export * from "./DonutChart35.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7aebf3",
  null
  
)

export default component.exports